/*
 * Gradual, low-priority warm-up of variant images on the product page.
 *
 * With "hide other variants' media" on, a variant's image is only added to the gallery after the
 * shopper picks it, so it downloads at that moment. This fetches those images ahead of time,
 * one at a time, after the main image has loaded and the browser is idle, using the gallery's own
 * `sizes` and the srcset from snippets/variant-image-preload.liquid so the browser picks the same
 * file the gallery will ask for. It never touches the gallery, variant pickers or cart.
 *
 * Skips: media already in the gallery, repeats, Save-Data / 2G connections, prefers-reduced-data.
 */
(function () {
  if (window.variantImagePreload) return;

  var MAX_IMAGES = 12;
  var GAP_MS = 250;
  var state = (window.variantImagePreload = { status: 'init', queued: 0, loaded: [], skipped: [] });

  function saveData() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches);
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
    else setTimeout(fn, 400);
  }

  function afterImage(img, fn) {
    if (!img || (img.complete && img.naturalWidth)) return fn();
    img.addEventListener('load', fn, { once: true });
    img.addEventListener('error', fn, { once: true });
  }

  function afterPageLoad(fn) {
    if (document.readyState === 'complete') return fn();
    window.addEventListener('load', fn, { once: true });
  }

  function start() {
    var template = document.querySelector('template[data-variant-image-preload]');
    if (!template) return (state.status = 'no-template');
    if (saveData()) return (state.status = 'save-data');

    var sectionId = template.dataset.sectionId;
    var gallery = document.querySelector('#MediaGallery-' + sectionId) || document.querySelector('media-gallery');
    var viewer = gallery && gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return (state.status = 'no-gallery');

    var main = viewer.querySelector('li.is-active .product__media img') || viewer.querySelector('.product__media img');
    if (!main) return (state.status = 'no-main-image');

    // Media already rendered in the gallery loads on its own, so never fetch it twice.
    var inGallery = {};
    viewer.querySelectorAll('li[data-media-id]').forEach(function (li) {
      inGallery[li.dataset.mediaId.split('-').pop()] = true;
    });

    var seenSrcset = {};
    var queue = [];
    template.content.querySelectorAll('[data-vip-media]').forEach(function (el) {
      var id = el.dataset.vipMedia;
      var img = el.querySelector('img');
      var srcset = img && img.getAttribute('srcset');
      if (!srcset || inGallery[id] || seenSrcset[srcset]) return state.skipped.push(id);
      seenSrcset[srcset] = true;
      queue.push({ id: id, srcset: srcset, src: img.getAttribute('src') });
    });
    queue = queue.slice(0, MAX_IMAGES);
    state.queued = queue.length;
    if (!queue.length) return (state.status = 'nothing-to-do');

    function next() {
      if (!queue.length) return (state.status = 'done');
      if (saveData()) return (state.status = 'save-data');
      if (document.hidden) {
        document.addEventListener('visibilitychange', function () { whenIdle(next); }, { once: true });
        return;
      }
      var item = queue.shift();
      var img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'low';
      img.setAttribute('fetchpriority', 'low');
      img.sizes = main.getAttribute('sizes') || '100vw';
      img.srcset = item.srcset;
      img.src = item.src;
      var finish = function () {
        state.loaded.push({ id: item.id, url: img.currentSrc || img.src });
        setTimeout(function () { whenIdle(next); }, GAP_MS);
      };
      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', finish, { once: true });
    }

    state.status = 'waiting';
    afterImage(main, function () {
      afterPageLoad(function () {
        state.status = 'running';
        whenIdle(next);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
